import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert } from "reactstrap";
import { getBuildingsByValuation } from "../../../../services/ValitanApiService";

const BuildingsTab = ({ valuationId }) => {
    const [buildings, setBuildings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!valuationId) return;

        const fetchBuildings = async () => {
            try {
                setLoading(true);
                const response = await getBuildingsByValuation(valuationId);

                if (response.status === 200 && response.data?.data) {
                    setBuildings(response.data.data);
                } else {
                    setBuildings([]);
                }
            } catch (error) {
                console.error("Failed to fetch buildings:", error);
                setBuildings([]);
            } finally {
                setLoading(false);
            }
        };

        fetchBuildings();
    }, [valuationId]);

    if (loading) {
        return (
            <div className="text-center my-3">
                <Spinner color="primary" />
            </div>
        );
    }

    if (!buildings.length) {
        return <Alert color="info">No buildings available</Alert>;
    }

    return (
        <div>
            <h5 className="mb-3 text-primary">Buildings</h5>
            <Table bordered hover responsive>
                <thead className="table-light">
                    <tr>
                        <th>#</th>
                        <th>Building Type</th>
                        <th>Year Built</th>
                        <th>Condition</th>
                        <th>No. of Floors</th>
                        <th>Room Count</th>
                        <th>Materials</th>
                        <th>Finishing Quality</th>
                        <th>Structural Issues</th>
                        <th>Tenancy Status</th>
                        <th>Monthly Rent</th>
                    </tr>
                </thead>
                <tbody>
                    {buildings.map((building, index) => (
                        <tr key={building.id}>
                            <td>{index + 1}</td>
                            <td>{building.building_type || "-"}</td>
                            <td>{building.year_built || "-"}</td>
                            <td>{building.condition || "-"}</td>
                            <td>{building.no_of_floors || "-"}</td>
                            <td>{building.room_count || "-"}</td>
                            <td>{building.materials || "-"}</td>
                            <td>{building.finishing_quality || "-"}</td>
                            <td>{building.structural_issues || "-"}</td>
                            <td>
                                {building.is_rented
                                    ? `${building.tenancy_status || "Rented"} (${building.tenancy_start} → ${building.tenancy_end})`
                                    : "Not rented"}
                            </td>
                            <td>
                                {building.is_rented
                                    ? new Intl.NumberFormat("en-TZ", {
                                        style: "currency",
                                        currency: "TZS",
                                    }).format(building.monthly_rent || 0)
                                    : "-"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default BuildingsTab;
